import { z } from 'zod';
import { defineEndpoint } from '../define';
import { ReleaseDetailSchema } from './shapes';

/** Manually re-sync workflow run states from GitHub (webhook fallback). */
export const reconcileRelease = defineEndpoint({
  method: 'POST',
  path: '/v1/releases/:releaseId/reconcile',
  params: z.object({ releaseId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: ReleaseDetailSchema }),
});
